export default "__VITE_ASSET__5b023b7d__"